import { track } from '../utils/analytics';
import { isNative } from '../utils/platformUtils';

// Exigence de review App Store : la politique de confidentialite doit etre
// accessible depuis l'app, pas seulement depuis la fiche du Store.
export const PRIVACY_POLICY_URL = 'https://upscale.li/privacy-policy.html';

// Sur natif, une ancre externe reste dans la WebView (page hors de l'app,
// sans barre d'adresse ni retour) : on passe par le navigateur systeme.
export async function openPrivacyPolicy() {
  track('privacy_policy_opened');
  if (isNative()) {
    const { Browser } = await import('@capacitor/browser');
    await Browser.open({ url: PRIVACY_POLICY_URL });
  } else {
    window.open(PRIVACY_POLICY_URL, '_blank', 'noopener');
  }
}

export default openPrivacyPolicy;
